import axios from "axios";
import url from "../config/urlServiceConfig";

const pPlusAPI = {
  getProjects: () => axios.get(`${url.pplus}/projects`),
  getPrograms: () => axios.get(`${url.pplus}/programs`),
  getPortfolios: () => axios.get(`${url.pplus}/portfolios`),
  getInitiatives: () => axios.get(`${url.pplus}/initiatives`),
};

export default pPlusAPI;
